<template>
  <section class="hero">
    <!-- Background image -->
    <div class="hero__bg">
      <img src="@/assets/images/s1.png" class="hero__bg-img">
      <div class="hero__overlay" />
    </div>

    <!-- Content -->
    <div class="hero__content">
      <p class="hero__eyebrow">Premium Aromatic Diffusers</p>
      <h1 class="hero__title">
        향기로 완성되는<br>
        <em>공간의 품격</em>
      </h1>
      <p class="hero__tagline">
        Perfume Wiz는 단순한 디퓨저가 아닌 <br>
        공간의 분위기를 디자인합니다.
      </p>
      <div class="hero__divider" />
      <button class="hero__cta" @click="$emit('scroll-down')">
        Explore Collection
      </button>
    </div>

    <!-- Scroll indicator -->
    <div class="hero__scroll-indicator" @click="$emit('scroll-down')">
      <span class="hero__scroll-text">Scroll</span>
      <div class="hero__scroll-line" />
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeroSection'
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/variables';

.hero {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-color: $color-forest;
}

.hero__bg {
  position: absolute;
  inset: 0;
  z-index: 0;

  &-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    filter: saturate(0.7);
  }
}

.hero__overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    135deg,
    rgba($color-forest, 0.80) 0%,
    rgba($color-forest, 0.45) 60%,
    rgba($color-black, 0.65) 100%
  );
}

.hero__content {
  position: relative;
  z-index: 1;
  text-align: center;
  padding: 0 24px;
  animation: fadeInUp 1s ease 0.3s both;

  @media (max-width: $bp-mobile) {
    padding: 0 20px;
  }
}

.hero__eyebrow {
  font-family: $font-body;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.28em;
  text-transform: uppercase;
  color: $color-gold;
  margin-bottom: 20px;
}

.hero__title {
  font-family: $font-heading;
  font-size: clamp(52px, 7vw, 92px);
  font-weight: 400;
  color: $color-ivory;
  line-height: 1.1;
  margin-bottom: 28px;

  em {
    font-style: italic;
    color: $color-gold-light;
  }
  @media (max-width: $bp-mobile) {
    font-size: clamp(45px, 7vw, 92px) !important;
  }
}

.hero__tagline {
  font-family: $font-body;
  font-size: clamp(14px, 1.6vw, 16px);
  font-weight: 300;
  color: rgba($color-ivory, 0.8);
  line-height: 1.8;
  max-width: 480px;
  margin: 0 auto 32px;
}

.hero__divider {
  width: 40px;
  height: 1px;
  background-color: $color-gold;
  margin: 0 auto 36px;
}

.hero__cta {
  display: inline-block;
  padding: 14px 44px;
  border: 1px solid $color-gold;
  background: transparent;
  color: $color-ivory;
  font-family: $font-body;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  cursor: pointer;
  transition: all $transition-base;

  &:hover {
    background-color: $color-gold;
    color: $color-forest;
  }
}

.hero__scroll-indicator {
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  cursor: pointer;

  @media (max-width: $bp-mobile) {
    bottom: 80px;
  }
}

.hero__scroll-text {
  font-family: $font-body;
  font-size: 10px;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: rgba($color-ivory, 0.55);
}

.hero__scroll-line {
  width: 1px;
  height: 50px;
  background: linear-gradient(to bottom, rgba($color-gold, 0.6), transparent);
  animation: scrollPulse 2s ease-in-out infinite;
}
</style>
